import React from 'react';
import { Typography, Select, Space, Input, Popover, Tabs, Table, Radio, Button } from 'antd';
import style from './index.module.scss';
import LineChartWrapper from '../Comp/wrapper';
import { SwatchesPicker } from 'react-color';
import { withRouter } from 'react-router';
import { post } from 'common/utils';

const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

class Comp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "",
            yAxisLeft: {
                "upper_limit": null,
                "lower_limit": null,
                "unit": null
            },
            yAxisRight: {
                "upper_limit": null,
                "lower_limit": null,
                "unit": null
            },
            metaList: [],
            metaOptions: [],
            selectedMeta: {
                name: '',
                y_axis: 'left',
                type: 'line',
                color: '#40A1E1',
            },
        };
    }

    componentDidMount() {
        // let self = this;
        let { registerDataFunc } = this.props;
        if (!!registerDataFunc) {
            registerDataFunc(() => {
                return Promise.resolve(this.getConf());
            });
        }
    }

    handleSearch = value => {
        console.log(value);
        post(process.env.REACT_APP_SERVER_PATH + "pyapi/meta_data/get_list", {
            keyword: "",
            page: 1,
            page_size: 10,
        })
            .then((retData) => {
                console.log(retData);
            });
    };

    addMeta = meta => {
        this.state.metaList.push({
            'name': meta.name,
            'tag_name': meta.tag_name,
        });
        this.state.metaOptions = [];
        this.forceUpdate();
    }

    getConf = () => {
        const { title, yAxisLeft, yAxisRight, metaList } = this.state;
        return {
            title,
            y_axis_left: yAxisLeft,
            y_axis_right: yAxisRight,
            meta_list: metaList,
        };
    };

    render() {
        let self = this;
        let { title, yAxisLeft, yAxisRight, metaOptions, metaList, selectedMeta } = this.state;

        return (
            <div className={style['wrapper']}>
                <div className="display_block">
                    <LineChartWrapper config={this.getConf()} />
                </div>
                <div className="edit_block">
                    <Tabs defaultActiveKey="2" tabPosition="left">
                        <TabPane tab="基本配置" key="1">
                            <Space direction="vertical">
                                <Space>
                                    <Text>标题</Text>
                                    <Input placeholder="请输入标题名" value={title} onChange={e => this.setState({ title: e.target.value })} style={{ width: 200 }} />
                                </Space>
                                <Space style={{ marginTop: 10 }}>
                                    <Text>左Y轴</Text>
                                    <Text>上限：</Text>
                                    <Input placeholder="请输入上限" value={yAxisLeft.upper_limit} onChange={e => { self.yAxisLeft.upper_limit = e.target.value; self.forceUpdate(); }} style={{ width: 100 }} />
                                    <Text style={{ marginLeft: 10 }}>下限：</Text>
                                    <Input placeholder="请输入下限" value={yAxisLeft.lower_limit} onChange={e => { self.yAxisLeft.lower_limit = e.target.value; self.forceUpdate(); }} style={{ width: 100 }} />
                                </Space>
                                <Space style={{ marginTop: 10 }}>
                                    <Text>右Y轴</Text>
                                    <Text>上限：</Text>
                                    <Input placeholder="请输入上限" value={yAxisRight.upper_limit} onChange={e => { self.yAxisRight.upper_limit = e.target.value; self.forceUpdate(); }} style={{ width: 100 }} />
                                    <Text style={{ marginLeft: 10 }}>下限：</Text>
                                    <Input placeholder="请输入下限" value={yAxisRight.lower_limit} onChange={e => { self.yAxisRight.lower_limit = e.target.value; self.forceUpdate(); }} style={{ width: 100 }} />
                                </Space>
                            </Space>
                        </TabPane>
                        <TabPane tab="数据项" key="2">
                            <Space>
                                <Space className="leftMetaList" direction="vertical">
                                    <Space className="meta-options-line">
                                        <Text>选择点位：</Text>
                                        <Select
                                            showSearch
                                            value={this.state.value}
                                            style={{ width: 250 }}
                                            defaultActiveFirstOption={false}
                                            showArrow={false}
                                            filterOption={false}
                                            onSearch={this.handleSearch}
                                            onChange={this.addMeta}
                                            notFoundContent={null}
                                        >
                                            {metaOptions.map(item => <Option value={item.tag_name}>{item.name}</Option>)}
                                        </Select>
                                    </Space>
                                    <Table
                                        dataSource={metaList}
                                        // rowKey="tag_name"
                                        locale={{ emptyText: "请添加点位" }}
                                        columns={[
                                            {
                                                title: "序号",
                                                render: (r, index) => {
                                                    return index;
                                                }
                                            }, {
                                                title: "点位号",
                                                dataIndex: "tag_name"
                                                // render: (text, r)=>{
                                                //     return text;
                                                // }
                                            }, {
                                                title: "名称",
                                                dataIndex: "name"
                                                // render: (text, r)=>{
                                                //     return text;
                                                // }
                                            }
                                        ]}
                                    />
                                </Space>
                                <Space className="rightConf" direction="vertical">
                                    {selectedMeta && <>
                                        <Space>
                                            <Text>名称：</Text>
                                            <Input
                                                value={selectedMeta.name}
                                                onChange={e => { selectedMeta.name = e.target.value; self.forceUpdate(); }}
                                                style={{ width: 200 }}
                                            />
                                        </Space>
                                        <Space>
                                            <Text>图表类型：</Text>
                                            <Radio.Group
                                                onChange={e => { selectedMeta.type = e.target.value; self.forceUpdate(); }}
                                                value={selectedMeta.type}
                                            >
                                                <Radio value="line">柱状图</Radio>
                                                <Radio value="bar">折线图</Radio>
                                            </Radio.Group>
                                        </Space>
                                        {/*<Space>
                                        <Text>单位：</Text>
                                        <Input
                                            value={selectedMeta.unit}
                                            onChange={e=>{selectedMeta.unit=e.target.value; self.forceUpdate();}}
                                            style={{ width: 100 }}
                                        />
                                    </Space>*/}
                                        <Space>
                                            <Text>线条颜色</Text>
                                            <Popover
                                                title="选择颜色"
                                                // trigger="click"
                                                placement="right"
                                                content={(
                                                    <Space direction="vertical">
                                                        <SwatchesPicker
                                                            color={selectedMeta.color}
                                                            onChangeComplete={color => {
                                                                if (color) {
                                                                    selectedMeta.color = color.hex;
                                                                    self.forceUpdate();
                                                                }
                                                            }}
                                                        />
                                                    </Space>
                                                )}
                                            >
                                                <div style={{ width: 100, height: 30, backgroundColor: selectedMeta.color, borderRadius: 5, cursor: 'pointer' }} />
                                            </Popover>
                                        </Space>
                                        <Space>
                                            <Text>Y轴位置：</Text>
                                            <Radio.Group
                                                onChange={e => { selectedMeta.y_axis = e.target.value; self.forceUpdate(); }}
                                                value={selectedMeta.y_axis}
                                            >
                                                <Radio value="left">左轴</Radio>
                                                <Radio value="right">右轴</Radio>
                                            </Radio.Group>
                                        </Space>
                                        <Button danger>删除</Button>
                                    </>}
                                </Space>
                            </Space>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }
};

export default withRouter(Comp);
